<template>
  <div class="app">
    <div class="header">
      <i class="el-icon-back" @click="goBack"></i>
      <span>{{title}}</span>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "标题",
      index: 0,
      token: '',
      c2token: ''
    };
  },
  created: function() {
    this.title = this.$route.query.title;
    this.index = this.$route.query.index;
    this.token = sessionStorage.getItem('token')
    this.c2token = sessionStorage.getItem('c2token')
  },
  updated: function() {
    this.title = this.$route.query.title;
    this.index = this.$route.query.index;
  },
  methods: {
    goBack() {
      console.log(this.$route.name);
      switch (this.$route.name) {
        case "youthpartybrach":
          sessionStorage.removeItem("youthPartyBrach");
          sessionStorage.removeItem("youthChoose");
          break;
        case "allienceActive":
          sessionStorage.removeItem("allienceActiveIndex");
          sessionStorage.removeItem("allienceActive");
          break;
        case "remoteedu":
          sessionStorage.removeItem("remoteeduIndex");
          sessionStorage.removeItem("remoteedu");
          break;
        case "/person/linechat":
          if(this.$children[0].ws!=''){
            let data = {
              type:'close',
              name:sessionStorage.getItem('name'),
            }
            this.$children[0].ws.send(JSON.stringify(data))
            this.$children[0].ws.close()
            // console.log(this.$children[0].ws);
          }
          break;
        default:
          break;
      }
      if (this.$route.name == "person/message/message") {
        if (this.$children[0].thing != "main") {
          this.$children[0].thing = "main";
          return;
        }
      }
      if (this.$route.name === '/partyReport') {
        console.log('header: ', sessionStorage.getItem('partybrach'))
        if (sessionStorage.getItem('partybrach')) {
          this.$router.push({
            path: '/index'
          })
        } else {
          this.$router.push({
            path: '/loginDp'
          })
        }
        return
      }
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  line-height: 1.5;
  text-align: center;
  position: fixed;
  width: 100%;
  z-index: 9;
  background: #fff;
  font-size: 0.34rem;
  padding: 0.16rem 0;
  box-shadow: 0px 0.06rem 0.06rem 0px rgba(0, 0, 0, 0.06);
  i {
    margin: 0 0.2rem;
  }
}
</style>